var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"icon-left":"file-excel","size":"is-small"},on:{"click":function($event){return _vm.requestExcel()}}},[_vm._v(" Exportar ")])}
var staticRenderFns = []

export { render, staticRenderFns }